<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="card">
          <div class="card-header">
            Detalhes
            <span class="span-is-link span-color-link ml-3">
              <!-- Editar -->
              <i v-if="canEditContract" class="fa fa-pencil-square-o" @click="editItem()"></i>

              <!-- Deletar -->
              <!-- <i v-if="canDeleteContract" class="fa fa-trash trash-color ml-3" @click="deleteItem()"></i> -->

              <!-- Duplicar copiar renovar contrato -->
              <span v-tooltip.top="'Renovar Contrato'">
                <i v-if="$store.getters['auth/isAdmin']" class="fa fa-refresh ml-3" @click="renewContract"></i>
              </span>

              <!-- Gerar Parcelas
              <span class="badge badge-warning ml-3" v-tooltip.top="'Gerar Parcelas'" @click="openInstallmentModal">
                <i class="fa fa-dollar"></i> Gerar Parcelas
              </span>
              -->

            </span>
          </div>
          <div class="card-body">
<!--            Detalhes gerais do contrato -->
              <h3>Detalhes do Contrato</h3>
              <b-table :items="tableItems" :fields="tableFields" bordered>
              </b-table>
              <!-- Botão para nova versão -->
              <b-button v-if="canEditContract" variant="primary" @click="addVersion()">+ Nova Versão</b-button>
<!--              <b-list-group-item v-if="contract.title">-->
<!--                  <span>{{ contract.title }}</span>-->
<!--                </b-list-group-item>-->
<!--                <b-list-group-item v-if="contract.description">-->
<!--                  <span>Descrição: {{ contract.description }}</span>-->
<!--                </b-list-group-item>-->
<!--                <b-list-group-item v-if="contract.customer">-->
<!--                  <span>Cliente: {{ contract.customer }}</span>-->
<!--                </b-list-group-item>-->
<!--                <b-list-group-item v-if="contract.value">-->
<!--                  <span>Valor do Contrato: {{ currency_moneys.find(c => c.value == contract.currency_money).icon }} {{ contract.value | formatPrice }}</span>-->
<!--                </b-list-group-item>-->

<!--            Detalhes de cada versão do contrato -->
            <section style="margin-top: 2rem">
                <h3>Versões</h3>
                <div v-for="(version, index) in contract.versions" :key="version.pk">
                  <b-card no-body>
                    <b-card-header header-tag="header" role="tab">
                      <b-button block v-b-toggle="'accordion-' + index" variant="link">{{ version.title }}</b-button>
                    </b-card-header>
                    <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        <b-row>
                          <b-col lg="4">
                            <b-list-group flush>
                              <b-list-group-item v-if="version.start_date">
                                <span>Data de início da versão: {{ version.start_date | formatDate }}</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.end_date">
                                <span>Data de fim da versão: {{ version.end_date | formatDate }}</span>
                              </b-list-group-item>
<!--                              limit months-->
                              <b-list-group-item v-if="version.limit_months">
                                <span>Duração do contrato (em meses): {{ version.limit_months }}</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.contract_type_display">
                                <span>Tipo de Contrato: {{ version.contract_type_display }}</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.contract_model">
                                <span>
                                  Modelo:
                                  <template v-if="version.contract_model === 'hour_package'">
                                    Pacote de horas
                                  </template>
                                  <template v-else-if="version.contract_model === 'fixed_value'">
                                    Valor fixo
                                  </template>
                                  <template v-else-if="version.contract_model === 'free_hours'">
                                    Horas livres
                                  </template>
                                </span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.value">
                                <div>
                                  <div>
                                   Valor: <span v-if="currency_moneys.find(c => c.value === contract.currency_money)">{{ currency_moneys.find(c => c.value == contract.currency_money).icon }}</span> {{ version.value | formatPrice }}<span v-if="(version.contract_type === 'm' || version.contract_type === 'p') && version.active" @click="toggleContent('mostrarExcedente')" class="question-text"> - Gerar excedente</span>
                                  </div>
                                  <div>
                                    <!-- Additional content that appears when the question is clicked -->
                                    <transition name="slide-fade">
                                      <div v-if="mostrarExcedente" class="extra-content">
                                         <section style="margin: 1.25rem 0 1.25rem 0">
                                          <div>
                                            <h5 style="margin-bottom: 1rem">Excedente</h5>
                                          </div>
                                          <div style="margin-bottom: 1rem">
                                            <label for="valorExcedente">Valor</label>
                                            <b-input-group prepend="R$">
                                              <b-input required name="valorExcedente" v-model="valorExcedente" type="number"></b-input>
                                            </b-input-group>
                                          </div>
                                          <div style="margin-bottom: 1rem">
                                            <label for="vencimentoExcedente">Vencimento</label>
                                              <datepicker
                                              name="vencimentoExcedente"
                                              v-model="vencimentoExcedente"
                                              format="dd/MM/yy"
                                              :highlighted="state.highlighted"
                                              input-class="form-control"
                                              :typeable="true"
                                              :use-utc="true"
                                              ></datepicker>
                                          </div>
                                          <div style="margin-bottom: 1rem">
                                            <label for="descricaoExcedente">Descrição</label>
                                            <b-textarea required name="descricaoExcedente" v-model="descricaoExcedente" type="text"></b-textarea>
                                          </div>
                                        </section>
                                        <button class="btn btn-primary" @click="adicionarExcedente(contract.pk)">Gerar excedente</button>
                                      </div>
                                    </transition>
                                  </div>
                                </div>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.payment_type">
                                <span>Forma de Pagamento: {{ payment_types.find(c => c.value == version.payment_type).text }}</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.due_date">
<!--                                se for mensal ou projeto, data da primeira cobrança. se for por hora, início de recorrência da cobrança. se for projeto e payment_type 'v', data da cobrança -->
                                <template v-if="version.contract_type === 'm' || version.contract_type === 'p'">
                                  Data da primeira cobrança: {{ version.due_date | formatDate }}
                                </template>
                                <template v-if="version.contract_type === 'h'">
                                  Início de recorrência da cobrança: {{ version.due_date | formatDate }}
                                </template>
                                <template v-if="version.contract_type === 'p' && version.payment_type === 'v'">
                                  Data da cobrança: {{ version.billing_date | formatDate }}
                                </template>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.number_installments">
                                <span>Nº de Parcelas: {{ version.number_installments }}</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.value_installments">
                                <span>Valor das Parcelas: {{ currency_moneys.find(c => c.value == contract.currency_money).icon }} {{ version.value_installments | formatPrice }}</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="contract.sinal">
                                <span>Sinal de Pagamento: {{ currency_moneys.find(c => c.value == contract.currency_money).icon }} {{ contract.sinal | formatPrice }}</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.success_fees_num">
                                <span>Honorários de êxito: {{ version.success_fees_num }}</span>
                              </b-list-group-item>
<!--                              model-->
                              <b-list-group-item v-if="version.limit_hours">
                                <span v-if="version.contract_type === 'm'">Teto de horas: {{ version.limit_hours }}h</span>
                                <span v-else>Horas contratadas: {{ version.limit_hours }}h</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.has_timebank">
                                <span>Banco de horas: Sim</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.timebank_hour_value">
                                <span>Valor da hora: R$ {{ version.timebank_hour_value | formatPrice }}</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.timebank_charge_frequency">
                                <span>Periodicidade para cobrança do banco de horas: A cada {{ version.timebank_charge_frequency }} <span v-if="version.timebank_charge_frequency === 1">mês</span><span v-else>meses</span></span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.billing_recurrence">
                                <span>Periodicidade da cobrança: A cada {{ version.billing_recurrence }} <span v-if="version.billing_recurrence === 1">mês</span><span v-else>meses</span></span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.date_of_readjustment">
                                <span>Data de Reajuste: {{ version.date_of_readjustment | formatDate }}</span>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.index_of_readjustment">
                                <div>
                                  <div>
                                   Índice de Reajuste: {{ version.index_of_readjustment }}<span v-if="version.active" @click="toggleContent('showReadjustment')" class="question-text"> - Aplicar reajuste</span>
                                  </div>
                                  <div>
                                    <!-- Additional content that appears when the question is clicked -->
                                    <transition name="slide-fade">
                                      <div v-if="showReadjustment" class="extra-content">
                                         <div>
                                          <section style="margin: 1.25rem 0 1.25rem 0">
                                            <div>
                                              <h5 style="margin-bottom: 1rem">Reajuste do índice <span v-if="version.index_type">{{ version.index_type }}</span></h5>
                                            </div>
                                            <div  style="margin-bottom: 1rem">
                                              <label for="indiceReajuste">Índice</label>
                                              <b-input required name="indiceReajuste" v-model="indiceReajuste" type="number" min="1" max="2" step="0.01"></b-input>
                                            </div>
                                            <div>
                                              <label for="aplicarIndiceApartirDe" >Considerar reajuste a partir de</label>
                                              <datepicker
                                                name="aplicarIndiceApartirDe"
                                                v-model="aplicarIndiceApartirDe"
                                                format="dd/MM/yy"
                                                :highlighted="state.highlighted"
                                                input-class="form-control"
                                                :typeable="true"
                                                :use-utc="true"
                                              ></datepicker>
                                            </div>
                                          </section>
                                          <button class="btn btn-primary" @click="reajustarIndice(contract.pk)">Reajustar Índice</button>
                                        </div>
                                      </div>
                                    </transition>
                                  </div>
                                </div>
                              </b-list-group-item>
                              <b-list-group-item v-if="version.index_type">
                                <span>Tipo de Índice: {{ version.index_type }}</span>
                              </b-list-group-item>
                            </b-list-group>
                          </b-col>
                          <b-col lg="8">
                            <b-card v-if="version.file && version.file.url">
                              <embed :src="version.file.url" type="application/pdf" width="100%" height="750px">
                            </b-card>
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </section>
          </div>
        </div>
      </b-col>
    </b-row>

    <contract-modal :editing-item="editingItem" :is-visible="isVisible" namespace="contracts" @clear-modal="clearModal" @success-response="successResponse"></contract-modal>
  </div>
</template>
<script>
import axios from 'axios';

import GenericForm from '../../components/GenericForm';
import ContractModal from './ContractModal';
import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    GenericForm,
    Datepicker,
    ContractModal,
  },
  data() {
    return {
      mostrarExcedente: false,
      showReadjustment: false,
      tableFields: [
        { key: 'title', label: 'Título' },
        { key: 'description', label: 'Descrição' },
        { key: 'customer', label: 'Cliente' },
        // { key: 'start_date', label: 'Início' },
        // { key: 'end_date', label: 'Término' }
      ],
      tableItems: [],
      indiceReajuste: 1,
      aplicarIndiceApartirDe: new Date(),
      state: {
        highlighted: {
          dates: [
            new Date()
          ],
          includeDisabled: true
        }
      },
      contract: {},
      defaultEditing: {},
      editingItem: {
        customer_pk: null,
        title: "",
        description: "",
        end_date: "",
        limit_months: 0,
        currency_money: "",
        sinal: 0,
        success_fees_num: 0,
        active: false,
        index_of_readjustment: 1,
        start_date: '',
        date_of_readjustment: '',
        version: {
          contract_type: '',
          customer_pk: null,
          title: '',
          description: '',
          success_fees: 0,
          success_fees_num: 0,
          start_date: '',
          limit_months: 0,
          limit_hours: 0,
          contract_hours: 0,
          date_of_readjustment: '',
          index_of_readjustment: 1,
          index_type: 'IGPM',
          end_date: '',
          value: 0,
          currency_money: 'r',
          due_date: '',
          payment_type: 'v',
          file: null,
          active: true,
          sinal: 0,
          number_installments: 1,
          has_hour_limit: false,
          has_time_bank: false,
          timebank_hour_value: 0,
          timebank_charge_frequency: 0,
          contract_model: 'hour_package',
          billing_recurrence: '1_month',
        },
      },
      isVisible: false,
      isInstallmentVisible: false,
      currency_moneys: [
        { value: 'r', text: 'Real', icon: 'R$' },
        { value: 'd', text: 'Dólar', icon: '$' },
        { value: 'e', text: 'Euro', icon: '€' },
      ],
      payment_types: [
        { value: 'v', text: 'A vista'},
        { value: 'p', text: 'Parcelado'},
        { value: 'm', text: 'Mensal'},
      ],
      installments: [],
      excedente: null,
      spanVisible: true,
      receivableVisible: true,
    }
  },
  created() {
    const pk = this.$route.params.pk;
    const contract = this.$store.state.contracts.items.find(e => e.pk == pk);

    this.$store.dispatch('customers/loadItems');

    if (contract) {
      this.contract = contract;
      this.updateTableItems();

      if (this.$route.query.generate == true) {
        this.openInstallmentModal();
      }

      if (contract.installments) {
        this.spanVisible = false;
      }

      if (contract.receivable_created) {
        this.receivableVisible = false;
      }

      // breadcrumb
      this.$store.dispatch('setBreadcrumbs', [{
        name: 'Home',
      }, {
        name: 'Contratos',
      }, {
        name: contract.title,
      }]);

      return;
    }

    axios.get('/contract/' + pk + '/')
      .then(response => {
        this.contract = response.data.data;
        this.updateTableItems();

        if (this.contract.installments) {
          this.spanVisible = false;
        }

        if (this.contract.receivable_created) {
          this.receivableVisible = false;
        }

        // breadcrumb
        this.$store.dispatch('setBreadcrumbs', [{
          name: 'Home',
        }, {
          name: 'Contratos',
        }, {
          name: this.contract.title
        }]);

        if (this.$route.query.generate == true) {
          this.openInstallmentModal();
        }
      });
  },
  destroyed() {
    this.$store.dispatch('setBreadcrumbs', []);
  },
  computed: {
    lastVersion() {
    if (Array.isArray(this.contract.versions) && this.contract.versions.length > 0) {
      return this.contract.versions[0];
    }
    return null;
  },
    canEditContract() {
      return this.$store.state.auth.user.permission_codes.includes('change_contract');
    },
    canDeleteContract() {
      return this.$store.state.auth.user.permission_codes.includes('delete_contract');
    },
    totalContract: function() {
      return this.installments.reduce((total, item) => total + parseFloat(item.value), 0)
    },
    valorExcedenteFormatado() {
      return this.valorExcedente
    }
  },
  methods: {
    toggleContent(content) {
      this[content] = !this[content];
    },
    isLastVersion(version) {
      return version.pk === this.lastVersion.pk;
    },
    updateTableItems() {
      this.tableItems = [
        {
          title: this.contract.title,
          description: this.contract.description,
          customer: this.contract.customer,
        }
      ];
    },
    async adicionarExcedente(contract_pk) {
      this.$swal.fire({
        title: 'Gerar Excedente',
        text: 'Deseja realmente gerar este excedente?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        focusCancel: true
      }).then((result) => {
        if (result.value) {
         axios.post(`/contract/${contract_pk}/create_extra_installment/`, {
          value: this.valorExcedente,
          due_date: this.vencimentoExcedente,
          description: this.descricaoExcedente,
           index: "Excedente",
          }).then((result) => {
            if (result.status === 200) {
              this.$snotify.success('Excedente gerado com sucesso.', 'Sucesso', {
                timeout: 4000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
              });

              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
            else {
              this.$snotify.error('Erro ao gerar excedente. Tente novamente.', 'Erro', {
                timeout: 4000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
              });

              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
          });
        }
      })
    },
    async reajustarIndice(contract_pk) {
      this.$swal.fire({
        title: 'Reajuste de Índice',
        text: 'Este contrato terá o valor das parcelas reajustadas. Deseja prosseguir?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        focusCancel: true
      }).then((result) => {
        if (result.value) {
          // Reajustar Índice
          axios.post(`/contract/${contract_pk}/readjustment/`, {
            indice: this.indiceReajuste,
            aplicar_indice_apartir_de: this.aplicarIndiceApartirDe
          }).then((result) => {
            if (result.status === 200) {
              this.$snotify.success('Índice reajustado com sucesso!', 'Sucesso', {
                timeout: 4000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
              })

              setTimeout(() => {
                window.location.reload();
              }, 3000);
            }
          }).catch((error) => {
            this.$snotify.error('Erro ao reajustar índice. Tente novamente.', 'Erro', {
              timeout: 4000,
              showProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true
            })

            setTimeout(() => {
              window.location.reload();
            }, 3000);
          });
        }
      });
    },
    notifySuccess(message, title) {
      this.$snotify.success(message, title, {
        timeout: 5000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    },
    clearModal() {
      this.editingItem = { ...this.defaultEditing };

      this.isVisible = false;
    },
    clearInstallmentModal() {
      this.editingItem = { ...this.defaultEditing };

      this.isInstallmentVisible = false;
    },
    editItem() {
      this.isVisible = true;
      this.editingItem = { ...this.contract };

      // Última versão do contrato
      const lastVersion = this.contract.versions[0];

      // Mescla os detalhes da última versão do contrato à editingItem
      if (lastVersion) {
        this.editingItem.version = { ...lastVersion };
        delete this.editingItem.versions;
      }

    },
    addVersion() {
      this.isVisible = true;
      const lastVersion = this.lastVersion;
      if (lastVersion) {
        // Pega os dados da última versão do contrato para carregar nos campos fixos do contrato principal, no formulário
        this.editingItem.pk = this.contract.pk;
        this.editingItem.customer_pk =  this.contract.customer_pk;
        this.editingItem.limit_months = this.contract.limit_months;
        this.editingItem.currency_money = this.contract.currency_money;
        this.editingItem.start_date = this.contract.start_date;
        this.editingItem.new_version = true;
        // Dados para os outros campos dinâmicos do formulário, conforme a versão
        this.editingItem.version = { ...lastVersion };
      }
      else {
        this.editingItem = { ...this.contract };
      }
    },
    openInstallmentModal() {
      this.isInstallmentVisible = true;

      // this.editingItem.employee_pk = this.$store.state.auth.user.pk;
    },
    async sendItem() {
      /*const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }*/
      this.$store.dispatch('contracts/editItem', this.editingItem)
      this.contract = {
        ...this.editingItem,
      }
    },
    sendInstallment() {
      const isValid = this.$refs.installment_observer.validate();
      if (!isValid) {
        return
      }

      const installments = this.installments.map((installment, i) => {
        installment.index = i + 1;
        installment.due_date = new Date(installment.due_date).toISOString().split('T')[0];

        return installment;
      })

      const pk = this.$route.params.pk;
      axios.post('/contract/installment/add/' + pk + '/', installments)
        .then((response) => {
          this.contract = response.data;
          // Fecha o modal
          this.isInstallmentVisible = false;
          // Desativa o botão de gerar parcelas
          this.spanVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    generateReceivable() {
      const pk = this.$route.params.pk;
      axios.post('/contract/receivable/add/' + pk + '/', this.installments)
        .then((response) => {
          this.contract = response.data;
          // Desativa o botão de gerar recebiveis
          this.receivableVisible = false;
          this.notifySuccess('Recebíveis criado com sucesso!', 'Sucesso');
        })
        .catch((error) => {
          console.log(error);
        });
    },
    renewContract() {
      this.$swal.fire({
        title: 'Renovar contrato',
        input: 'number',
        inputPlaceholder: 'Meses',
        text: 'Por quanto tempo deseja renovar esse contrato?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const renewal_months = parseInt(result.value);
          this.$store.dispatch('contracts/renewItem', { pk: this.contract.pk, renewal_months: renewal_months }).then((response) => {
            if (response.status === 200) {
              this.$snotify.success("Contrato renovado.", "Sucesso", {
                timeout: 4000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
              })
              // Delay the reload to allow Snotify to display the notification
              setTimeout(() => {
                window.location.reload();
              }, 3000); // Wait for 3 seconds, matching the notification timeout
            } else {
              this.$snotify.error("Erro ao renovar contrato.", "Erro", {
                timeout: 4000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true
              })
              // Delay the reload to allow Snotify to display the notification
              setTimeout(() => {
                window.location.reload();
              }, 3000); // Wait for 3 seconds, matching the notification timeout
            }
          })
        }
      });
    },
    deleteItem(item) {
      this.$swal.fire({
        title: 'Deletar item',
        text: 'Deseja realmente apagar esse item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('contracts/deleteItem', item);
        }
      });
    },
    successResponse() {
      const pk = this.$route.params.pk;

        axios.get('/contract/' + pk + '/')
          .then(response => {
            this.contract = response.data.data;
          });
    },
    shown() {
      // Distribui as parcelas no modal.
      const installments = [];

      if (this.contract.contract_type === 'm') {
        // Mensal
        const totalValue = this.contract.value;

        for (let i = 0; i < this.contract.limit_months; i++) {
          const date = new Date(this.contract.due_date);
          date.setMonth(date.getMonth() + (i));

          installments.push({
            due_date: date.toISOString().split('T')[0],
            value: totalValue,
          });
        }
      }

      else if (this.contract.contract_type === 'f') {
        // Fixo
        const totalValue = this.contract.value / this.contract.limit_months;

        for (let i = 0; i < this.contract.limit_months; i++) {
          const date = new Date(this.contract.due_date);
          date.setMonth(date.getMonth() + (i));

          installments.push({
            due_date: date.toISOString().split('T')[0],
            value: totalValue,
          });
        }
      } else if (this.contract.contract_type === 'h') {
        // Hora
        const totalPrice = Number(this.$route.query.total_price.replace('.', '').replace(',', '.'));
        // const totalValue = totalPrice / this.contract.limit_months;

        for (let i = 0; i < 1; i++) {
          const date = new Date(this.contract.due_date);
          date.setMonth(date.getMonth() + (i));

          installments.push({
            due_date: date.toISOString().split('T')[0],
            value: totalPrice,
          });
        }
      }

      this.installments = installments;
    },
    addInstallment() {
      this.installments.push({
        index: this.installments.length + 1,
        due_date: null,
        value: 0,
      });
    },
    removeInstallment(i) {
      this.installments.splice(i, 1);
    }
  }
}

</script>

<style>
.question-text {
  cursor: pointer;
  color: gray;
}

/* Slide-fade transition */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter, .slide-fade-leave-to /* .slide-fade-leave-active in <2.1.8 */
{
  max-height: 0;
  opacity: 0;
}
</style>

<!-- Display das parcelas
                  <b-list-group flush>
                    <b-list-group-item>
                      <span v-if="contract.contract_type_display === 'por hora'" class="float-right badge badge-warning ml-3" @click="generateReceivable">
                        <i class="fa fa-dollar"></i> Gerar Recebíveis
                      </span>
                      <h5>Parcelas</h5>
                      <span v-for="item in contract.installments" :key="item.installment_number">
                        <span>{{ item.installment_number }}</span> -
                        <span>{{ item.installment_due_date | formatDate }}</span> -
                        <span>R$ {{ item.installment_value | formatPrice }}</span>
                        <br>
                      </span>
                    </b-list-group-item>
                  </b-list-group>
-->


<!-- Modal usado para gerar parcelas -->
<!-- <ValidationObserver ref="installment_observer" v-slot="{ passes }">
      <b-modal :visible="isInstallmentVisible" :title="'Gerar Parcelas'" @ok.prevent="passes(sendInstallment)" @hidden="clearInstallmentModal" @shown="shown" cancel-title="Cancelar" ok-title="Salvar Parcelas">
        <b-row v-for='(installment, i) in installments' :key="i">

          <b-col sm="1">
            <b-form-group>
              <template slot="label">
                &nbsp;
              </template>
              <div style="padding-top: 10px;">{{ i + 1 }}</div>
            </b-form-group>
          </b-col>

          <b-col :sm="contract.contract_type != 'm' ? 5 : 6">
            <b-form-group label-for="item-installment_due_date">
              <template slot="label">
                Vencimento
              </template>
              <datepicker
                id="item-installment_due_date"
                v-model="installment.due_date"
                format="dd/MM/yy"
                :highlighted="state.highlighted"
                input-class="form-control"
                :typeable="false"
                :use-utc="true"
              >
              </datepicker>
            </b-form-group>
          </b-col>

          <b-col :sm="contract.contract_type != 'm' ? 4 : 5">
            <b-form-group label-for="item-value">
              <template slot="label">
                Valor
              </template>
              <b-input-group prepend="R$" class="mb-2 mr-sm-2 mb-sm-0">
                <b-input id="item-value" type="number" min="0" step="0.01" v-model="installment.value"></b-input>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="2" v-if="contract.contract_type != 'm'">
            <b-form-group label-for="item-value">
              <template slot="label">
                &nbsp;
              </template>
              <b-button variant="link" style="color: red; " @click="removeInstallment(i)">
                <i class="fa fa-close"></i>
              </b-button>
            </b-form-group>
          </b-col>

        </b-row>
        <div class="text-center">
          <b-button variant="success" v-if="contract.contract_type != 'm'" @click="addInstallment">
            <i class="fa fa-plus"></i> Adicionar parcela
          </b-button>
        </div>
        <div class="text-right lead">Total: R$ {{ totalContract | formatPrice }}</div>
      </b-modal>
    </ValidationObserver>
-->
